<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas22bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 55px; top: 70px">
      <p>
        Toca y selecciona el nombre de las comidas que están dibujadas abajo.
      </p>
    </span>

    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Pescado al horno"
        ref="1"
        v-on:click="saveOption('comidas', 1)"
        :onload="loadOption('comidas', 1)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 40px;
          margin-top: 150px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Pescado al horno</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Guiso de lentejas"
        ref="2"
        v-on:click="saveOption('comidas', 2)"
        :onload="loadOption('comidas', 2)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 365px;
          margin-top: 150px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Guiso de lentejas</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Pollo asado"
        ref="3"
        v-on:click="saveOption('comidas', 3)"
        :onload="loadOption('comidas', 3)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 690px;
          margin-top: 150px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Pollo asado</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Tomates rellenos"
        ref="4"
        v-on:click="saveOption('comidas', 4)"
        :onload="loadOption('comidas', 4)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 40px;
          margin-top: 255px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Tomates rellenos</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Sopa de letras"
        ref="5"
        v-on:click="saveOption('comidas', 5)"
        :onload="loadOption('comidas', 5)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 365px;
          margin-top: 255px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Sopa de letras</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Tallarines con tuco"
        ref="6"
        v-on:click="saveOption('comidas', 6)"
        :onload="loadOption('comidas', 6)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 690px;
          margin-top: 255px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Tallarines con tuco</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Arroz con leche"
        ref="7"
        v-on:click="saveOption('comidas', 7)"
        :onload="loadOption('comidas', 7)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 40px;
          margin-top: 360px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Arroz con leche</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Torta de chocolate"
        ref="8"
        v-on:click="saveOption('comidas', 8)"
        :onload="loadOption('comidas', 8)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 365px;
          margin-top: 360px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Torta de chocolate</p>
      </span>
    </label>
    <label class="imageCheckBox">
      <input
        type="checkbox"
        name="comidas"
        value="Helado de menta"
        ref="9"
        v-on:click="saveOption('comidas', 9)"
        :onload="loadOption('comidas', 9)"
      />
      <span
        class="checkBoxMark"
        style="
          margin-left: 690px;
          margin-top: 360px;
          width: 290px;
          height: 80px;
          border-radius: 12px;
        "
      >
        <p class="textBase" style="font-size: 30px">Helado de menta</p>
      </span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 39px;
  top: 84px;
}
/* Rectangle 24 */
#rectangle01 {
  position: absolute;
  left: 3.81%;
  right: 67.19%;
  top: 20.31%;
  bottom: 69.4%;

  background: #d2d1c2;
  border-radius: 18px;
}
#rectangle01:hover {
  background: #c7c6be;
}
#rectangle01:active {
  background: #1bb4b4;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 69.mp4",
        "cas/Video 70.mp4",
        "cas/Video 71.mp4",
        "cas/Video 72.mp4",
        "cas/Video 73.mp4",
        "cas/Video 74.mp4",
        "cas/Video 75.mp4",
        "cas/Video 76.mp4",
        "cas/Video 77.mp4",
        "cas/Video 78.mp4",

      ],
    };
  },
  methods: {
    dbId(name, option) {
      return `${this.$parent.pageID()}-${name}-${option}`;
    },
    async loadOption(name, option) {
      var id = this.dbId(name, option);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[option].checked = value.option;

      console.log("option loaded: " + id + ", " + value.option);
    },
    saveOption(name, option) {
      var id = this.dbId(name, option);
      var value = this.$refs[option].checked;

      this.$db.options
        .put({
          id: id,
          option: value,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + value);
    },
  },
  mounted() {},
};
</script>